// /* eslint-disable */

// /**
//  * Dependencies:
//  * - Custom select component
//  *
//  * Required translation strings:
//  * - addToCart
//  * - noStock
//  * - noVariant
//  * - onlyXLeft
//  */

// if (!customElements.get('variant-picker')) {
//   class VariantPicker extends HTMLElement {
//     constructor() {
//       super();
//       this.section = this.closest('.js-product');
//       this.productForm = this.section.querySelector('.js-product-form-main');
//       this.optionSelectors = this.querySelectorAll('.option-selector');
//       this.data = this.getProductData();
//       this.variant = this.getSelectedVariant();
//       this.selectedOptions = this.getSelectedOptions();
//       this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

//       this.addEventListener('change', this.handleVariantChange.bind(this));

//       // Defer these to allow for quick-add modal to full initialize
//       setTimeout(() => {
//         this.updateAvailability();
//         this.updateAddToCartButton();
//       });
//     }

//     /**
//      * Handles 'change' events on the variant picker element.
//      * @param {object} evt - Event object.
//      */
//     handleVariantChange(evt) {
//       this.selectedOptions = this.getSelectedOptions();
//       this.variant = this.getSelectedVariant();
//       this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

//       if (this.variant) {
//         this.updateMedia();
//         this.updateUrl(evt);
//         this.updateVariantInput();
//       }

//       this.updateAddToCartButton();
//       this.updateAvailability();
//       this.updatePrice();
//       this.updateWeight();
//       this.updateBarcode();
//       this.updateBackorderText();
//       this.updatePickupAvailability();
//       this.updateSku();
//       this.updateMetafieldVisibility();
//       VariantPicker.updateLabelText(evt);

//       if (!this.preSelection) {
//         this.dispatchEvent(new CustomEvent('on:variant:change', {
//           bubbles: true,
//           detail: {
//             form: this.productForm,
//             variant: this.variant,
//             product: this.data.product
//           }
//         }));
//       }
//     }

//     /**
//      * Shows/hides variant metafield elements on the page as necessary
//      */
//     updateMetafieldVisibility() {
//       document.querySelectorAll('[data-variant-metafield]').forEach((elem) => {
//         elem.classList.toggle('hidden', elem.dataset.variantMetafield !== this.variant?.id.toString());
//       });
//     }

//     /**
//      * Updates the "Add to Cart" button label and disabled state.
//      */
//     updateAddToCartButton() {
//       this.productForm = this.section.querySelector('.js-product-form-main');
//       if (!this.productForm) return;

//       this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
//       const variantAvailable = this.variant && this.variant.available;

//       this.addBtn.disabled = !variantAvailable || this.preSelection;

//       if (this.preSelection) {
//         this.addBtn.textContent = theme.strings.noSelectedVariant;
//       } else {

//         const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
//         this.addBtn.textContent = variantAvailable
//           ? this.addBtn.dataset.addToCartText
//           : unavailableStr;
//       }
//     }

//     /**
//      * Updates the availability status of an option.
//      * @param {Element} optionEl - Option element.
//      * @param {boolean} exists - Does this option lead to a variant that exists?
//      * @param {boolean} available - Does this option lead to a variant that is available to buy?
//      */
//     static updateOptionAvailability(optionEl, exists, available) {
//       const el = optionEl;
//       const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
//       el.classList.toggle('is-unavailable', !available);
//       el.classList.toggle('is-nonexistent', !exists);

//       if (optionEl.classList.contains('custom-select__option')) {
//         const em = el.querySelector('em');

//         if (em) {
//           em.hidden = available;
//         }

//         if (!available) {
//           if (em) {
//             em.textContent = unavailableText;
//           } else {
//             el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
//           }
//         }
//       } else if (!available) {
//         el.nextElementSibling.title = unavailableText;
//       } else {
//         el.nextElementSibling.removeAttribute('title');
//       }
//     }

//     /**
//      * Updates the availability status in option selectors.
//      */
//     updateAvailability() {
//       if (this.dataset.showAvailability === 'false') return;
//       const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
//       let currVariant = this.variant;

//       if (!this.variant) {
//         currVariant = { options: this.selectedOptions };
//       }

//       if (availabilityMethod === 'selection') {
//         // Flag all options as unavailable
//         this.querySelectorAll('.js-option').forEach((optionEl) => {
//           VariantPicker.updateOptionAvailability(optionEl, false, false);
//         });

//         // Flag selector options as available or sold out, depending on the variant availability
//         this.optionSelectors.forEach((selector, selectorIndex) => {
//           this.data.product.variants.forEach((variant) => {
//             let matchCount = 0;

//             variant.options.forEach((option, optionIndex) => {
//               if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
//                 matchCount += 1;
//               }
//             });

//             if (matchCount === currVariant.options.length - 1) {
//               const options = selector.querySelectorAll('.js-option');
//               const optionEl = Array.from(options).find((opt) => {
//                 if (selector.dataset.selectorType === 'dropdown') {
//                   return opt.dataset.value === variant.options[selectorIndex];
//                 }
//                 return opt.value === variant.options[selectorIndex];
//               });

//               if (optionEl) {
//                 VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
//               }
//             }
//           });
//         });
//       } else {
//         this.optionSelectors.forEach((selector, selectorIndex) => {
//           const options = selector.querySelectorAll('.js-option:not([data-value=""])');
//           options.forEach((option) => {
//             const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
//             // any available variants with previous options and this one locked in?
//             let variantsExist = false;
//             let variantsAvailable = false;
//             this.data.product.variants.forEach((v) => {
//               let matches = 0;
//               for (let i = 0; i < selectorIndex; i += 1) {
//                 if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
//                   matches += 1;
//                 }
//               }
//               if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
//                 variantsExist = true;
//                 if (v.available) {
//                   variantsAvailable = true;
//                 }
//               }
//             });
//             VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
//           });
//         });
//       }
//     }

//     /**
//      * Updates the backorder text and visibility.
//      */
//     updateBackorderText() {
//       this.backorder = this.backorder || this.section.querySelector('.backorder');
//       if (!this.backorder) return;

//       let hideBackorder = true;

//       if (this.variant && this.variant.available) {
//         const { inventory } = this.data.formatted[this.variant.id];

//         if (this.variant.inventory_management && inventory === 'none') {
//           const backorderProdEl = this.backorder.querySelector('.backorder__product');
//           const prodTitleEl = this.section.querySelector('.product-title');
//           const variantTitle = this.variant.title.includes('Default')
//             ? ''
//             : ` - ${this.variant.title}`;

//           backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
//           hideBackorder = false;
//         }
//       }

//       this.backorder.hidden = hideBackorder;
//     }

//     /**
//      * Updates the color option label text.
//      * @param {object} evt - Event object
//      */
//     static updateLabelText(evt) {
//       const selector = evt.target.closest('.option-selector');
//       if (selector.dataset.selectorType === 'dropdown') return;

//       const colorText = selector.querySelector('.js-color-text');
//       if (!colorText) return;

//       colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
//     }

//     /**
//      * Updates the product media.
//      */
//     updateMedia() {
//       if (!this.variant.featured_media) return;

//       if (this.section.matches('quick-add-drawer')) {
//         this.section.updateMedia(this.variant.featured_media.id);
//       } else {
//         this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
//         if (!this.mediaGallery) return;

//         const variantMedia = this.mediaGallery.querySelector(
//           `[data-media-id="${this.variant.featured_media.id}"]`
//         );
//         this.mediaGallery.setActiveMedia(variantMedia, true, true);
//       }
//     }

//     /**
//      * Updates the pick up availability.
//      */
//     updatePickupAvailability() {
//       this.pickUpAvailability =
//         this.pickUpAvailability || this.section.querySelector('pickup-availability');
//       if (!this.pickUpAvailability) return;

//       if (this.variant && this.variant.available) {
//         this.pickUpAvailability.getAvailability(this.variant.id);
//       } else {
//         this.pickUpAvailability.removeAttribute('available');
//         this.pickUpAvailability.innerHTML = '';
//       }
//     }

//     /**
//      * Updates the price.
//      */
//     updatePrice() {
 
//       this.price = this.price || this.section.querySelector('.product-info__price > .price');
     
//       if (!this.price) return;

//       let { variant } = this;
//       if (this.preSelection) {
//         variant = this.data.product.variants[0];
//         for (let i = 1; i < this.data.product.variants.length; i += 1) {
//           if (this.data.product.variants[i].price < variant.price) variant = this.data.product.variants[i];
//         }
//       }

//       if (this.variant) {
       
//         const priceCurrentEl = this.price.querySelector('.price__current');
//         const priceWasEl = this.price.querySelector('.price__was');
//         const priceWasdisEl = this.price.querySelector('.price__was_dis');
        
//         const unitPriceEl = this.price.querySelector('.unit-price');
    
//         const priceSpan = priceCurrentEl.querySelector('.js-value > span');
  
//         const discount_percentage_container = this.price.querySelector('#discount_percentage');

//         // Update price.
//         if (discount_percentage_container) {
// const discount_percentage = this.price.querySelector('#discount_percentage').innerHTML;
//   // Assuming priceWasdisEl and priceCurrentdisEl are defined in the broader function scope
//   priceWasdisEl.querySelector('.js-value').innerHTML = this.data.formatted[variant.id].price;

//   let priceString = this.data.formatted[variant.id].price;

//   // Clean the price string
//   priceString = priceString.replace(/[^0-9.,]/g, '');
//   priceString = priceString.replace(/[.,]/g, '');

//   let formattedPrice = parseFloat(priceString).toFixed(2);
//   let correct_format = formattedPrice / 100;
//   let final_price = correct_format % 1 === 0 
//     ? correct_format.toString() 
//     : correct_format.toFixed(2);

//   const discountVar = 100 - discount_percentage;
//   const finalDiscountVariable = discountVar * 0.01;
//   const discountedPrice = final_price * finalDiscountVariable;
//   const discountedPriceInCents = Math.round(discountedPrice * 100);

//   const formattedDiscountedPrice = Shopify.formatMoney(discountedPriceInCents, Shopify.money_format);

//   console.log(Shopify.formatMoney(discountedPriceInCents, Shopify.money_format));

//   priceCurrentEl.querySelector('.js-value').innerHTML = formattedDiscountedPrice;

// } else if (variant.compare_at_price > variant.price) {
        
//   priceCurrentEl.querySelector('.js-label').textContent = theme.strings.salePrice;
//   priceCurrentEl.querySelector('.js-value').innerHTML = this.data.formatted[variant.id].price;

//   if (priceWasEl) {
//     priceWasEl.querySelector('.js-label').textContent = theme.strings.regularPrice;
//     priceWasEl.querySelector('.js-value').innerHTML = this.data.formatted[variant.id].compareAtPrice || '';
//   }

// } else {

//   priceCurrentEl.querySelector('.js-label').textContent = theme.strings.regularPrice;
//   priceCurrentEl.querySelector('.js-value').innerHTML = this.data.formatted[variant.id].price;

//   if (priceWasEl) {
//     priceWasEl.querySelector('.js-label').textContent = '';
//     priceWasEl.querySelector('.js-value').innerHTML = '';
//   }
// }
//    // Update unit price, if specified.
//         if (this.variant.unit_price_measurement) {
     
//           const valueEl = this.price.querySelector('.unit-price__price');
//           const unitEl = this.price.querySelector('.unit-price__unit');
//           const value = this.variant.unit_price_measurement.reference_value;
//           const unit = this.variant.unit_price_measurement.reference_unit;

//           valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
//           unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
//         }

//         unitPriceEl.hidden = !this.variant.unit_price_measurement;
//         this.price.classList.toggle(
//           'price--on-sale',
//           this.variant.compare_at_price > this.variant.price
//         );
//         this.price.classList.toggle('price--sold-out', !this.variant.available && !this.preSelection);
//       }

//       this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
//       this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
//       const from = this.price.querySelector('.price__from');
//       if (from) {
//         from.hidden = !this.preSelection;
//       }
//     }

//     /**
//      * Updates the weight.
//      */
//     updateWeight() {
//       this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
//       if (this.weights.length === 0) return;

//       const weightAvailable = this.variant && this.variant.weight > 0;
//       this.weights.forEach((weight) => {
//         weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
//         weight.hidden = !weightAvailable;
//       });
//     }

//     /**
//      * Updates the Barcode.
//      */
//     updateBarcode() {
//       this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
//       if (this.barcodes.length === 0) return;

//       const barcodeAvailable = this.variant && this.variant.barcode;
//       this.barcodes.forEach((barcode) => {
//         barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
//         barcode.parentNode.hidden = !barcodeAvailable;
//       });
//     }

//     /**
//      * Updates the SKU.
//      */
//     updateSku() {
//       this.sku = this.sku || this.section.querySelector('.product-sku__value');
//       if (!this.sku) return;

//       const skuAvailable = this.variant && this.variant.sku;
//       this.sku.textContent = skuAvailable ? this.variant.sku : '';
//       this.sku.parentNode.hidden = !skuAvailable;
//     }

//     /**
//      * Updates the url with the selected variant id.
//      * @param {object} evt - Event object.
//      */
//     updateUrl(evt) {
//       if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
//       window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
//     }

//     /**
//      * Updates the value of the hidden [name="id"] form inputs.
//      */
//     updateVariantInput() {
//       this.forms =
//         this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

//       this.forms.forEach((form) => {
//         const input = form.querySelector('input[name="id"]');
//         input.value = this.variant.id;
//         input.dispatchEvent(new Event('change', { bubbles: true }));
//       });
//     }

//     /**
//      * Gets the selected option element from each selector.
//      * @returns {Array}
//      */
//     getSelectedOptions() {
//       const selectedOptions = [];

//       this.optionSelectors.forEach((selector) => {
//         if (selector.dataset.selectorType === 'dropdown') {
//           const selectedText = selector.querySelector('.custom-select__btn').textContent.trim();
//           selectedOptions.push(selectedText === this.dataset.placeholderText ? null : selectedText);
//         } else {
//           const selected = selector.querySelector('input:checked');
//           selectedOptions.push(selected ? selected.value : null);
//         }
//       });

//       return selectedOptions;
//     }

//     /**
//      * Gets the product data.
//      * @returns {?object}
//      */
//     getProductData() {
//       const dataEl = this.querySelector('[type="application/json"]');
//       return JSON.parse(dataEl.textContent);
//     }

//     /**
//      * Get selected variant data.
//      * @returns {?object} Variant object, or null if one is not selected.
//      */
//     getSelectedVariant() {
//       const selectedOptions = this.getSelectedOptions();
//       return this.data.product.variants.find(
//         (v) => v.options.every((val, index) => val === selectedOptions[index])
//       );
//     }
//   }

//   customElements.define('variant-picker', VariantPicker);
// }





/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();
      this.selectedOptions = this.getSelectedOptions();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      this.addEventListener('change', this.handleVariantChange.bind(this));

      // Defer these to allow for quick-add modal to full initialize
      setTimeout(() => {
        this.initializeListedVariantSelection();
      });
    }

    /**
     * Button/fieldset pickers: choose a coherent variant (form id, URL, then first available)
     * and sync every option row, then fire one change so handleVariantChange runs once.
     */
    initializeListedVariantSelection() {
      const hasListed = this.querySelector('.option-selector[data-selector-type="listed"]');
      if (hasListed) {
        const variant = this.getDefaultVariantForAutoSelect();
        if (variant && this.syncListedPickersToVariant(variant)) {
          return;
        }
      }

      // Dropdown: custom-select may dispatch change separately; fallback if a listed radio is checked
      const preselectedRadio = this.querySelector(
        '.option-selector[data-selector-type="listed"] input.js-option:checked'
      );
      if (preselectedRadio) {
        VariantPicker.refreshListedLabelTexts(this);
        preselectedRadio.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        this.updateAvailability();
        this.updateAddToCartButton();
        // Server-selected dropdowns fire no change event on load (custom-select
        // leaves a server selection alone), so nothing else would repaint the
        // sticky bar. Mirror the server-rendered #pdp-price-container so the
        // sticky price always matches the main price block (Fix 10).
        // BYO configurator owns the sticky price on its own template.
        if (!document.querySelector('.byo-configurator, [data-byo-continue]')) {
          this.syncStickyAtcPrice(this.variant);
        }
      }
    }

    /**
     * Variant to show on load: hidden form input, ?variant=, else first available, else first in list.
     * @returns {?object}
     */
    getDefaultVariantForAutoSelect() {
      const variants = this.data?.product?.variants;
      if (!variants?.length) return null;

      const byId = (id) =>
        id && variants.find((v) => String(v.id) === String(id));

      this.productForm = this.section?.querySelector('.js-product-form-main');
      const formId = this.productForm?.querySelector('input[name="id"]')?.value;
      const urlId = new URLSearchParams(window.location.search).get('variant');

      return byId(formId) || byId(urlId) || variants.find((v) => v.available) || variants[0];
    }

    /**
     * For each listed option group, check the input matching variant.options[index]. One bubbling change at the end.
     * @param {object} variant
     * @returns {boolean} True if a change event was dispatched
     */
    syncListedPickersToVariant(variant) {
      if (!variant?.options?.length) return false;

      this.optionSelectors = this.querySelectorAll('.option-selector');
      const picks = [];
      let failed = false;

      this.optionSelectors.forEach((selector, optionIndex) => {
        if (selector.dataset.selectorType !== 'listed') return;
        const want = variant.options[optionIndex];
        if (want === undefined || want === null) {
          failed = true;
          return;
        }

        const wantNorm = String(want).trim();
        const inputs = selector.querySelectorAll('input.js-option');
        const match = Array.from(inputs).find((input) => String(input.value).trim() === wantNorm);

        if (!match) {
          failed = true;
          return;
        }
        picks.push(match);
      });

      if (failed || picks.length === 0) return false;

      picks.forEach((input) => {
        input.checked = true;
      });

      const lastListedInput = picks[picks.length - 1];
      VariantPicker.refreshListedLabelTexts(this);
      lastListedInput.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    /**
     * Keep legend ".js-color-text" in sync for every listed group (needed when setting many radios at once).
     * @param {HTMLElement} picker
     */
    static refreshListedLabelTexts(picker) {
      picker.querySelectorAll('.option-selector[data-selector-type="listed"]').forEach((selector) => {
        const checked = selector.querySelector('input.js-option:checked');
        const legendValue = selector.querySelector('.js-color-text');
        if (!checked || !legendValue) return;

        let label = checked.nextElementSibling;
        if (!label || label.tagName !== 'LABEL') {
          const id = checked.getAttribute('id');
          if (id && typeof CSS !== 'undefined' && CSS.escape) {
            label = selector.querySelector(`label[for="${CSS.escape(id)}"]`);
          }
        }

        const valueEl = label?.querySelector?.('.js-value');
        if (valueEl) {
          legendValue.textContent = valueEl.textContent.replace(/\s+/g, ' ').trim();
        }
      });
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateMetafieldVisibility();
      VariantPicker.updateLabelText(evt);

      if (!this.preSelection) {
        this.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product
          }
        }));
      }
    }

    /**
     * Shows/hides variant metafield elements on the page as necessary
     */
    updateMetafieldVisibility() {
      document.querySelectorAll('[data-variant-metafield]').forEach((elem) => {
        elem.classList.toggle('hidden', elem.dataset.variantMetafield !== this.variant?.id.toString());
      });
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const shouldDisable = !variantAvailable || this.preSelection;
      const stickyAtc = this.section.querySelector('#sticky-atc-button');

      let unavailableStr;
      let addToCartLabel;
      let mainLabel;
      if (!this.preSelection) {
        unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
        addToCartLabel = this.addBtn?.dataset.addToCartText || stickyAtc?.dataset.addToCartText;

        // Main button only: append the selected variant's effective price to
        // the label. The sticky button keeps the bare label (price is shown
        // separately in .sticky-container__atc-price via syncStickyAtcPrice()).
        mainLabel = addToCartLabel;
        if (variantAvailable) {
          let formattedPrice = this.getEffectivePriceText();

          // Fallback to the raw variant price if #pdp-price-container is not
          // available (e.g. on quick-add modal or non-PDP contexts).
          if (!formattedPrice
            && typeof Shopify !== 'undefined'
            && typeof Shopify.formatMoney === 'function') {
            formattedPrice = Shopify.formatMoney(this.variant.price, Shopify.money_format);
          }

          // The quick-add drawer keeps the bare label. The price is right
          // above the button there, in a block the size of the panel, so
          // repeating it inside the button says nothing and makes the only
          // action in the drawer read as a line of data. The product page
          // keeps the price in the label: there the button can be a long
          // scroll away from the price block.
          const inQuickAdd = !!this.closest('quick-add-drawer');

          if (formattedPrice && !inQuickAdd) {
            // Strip any HTML (e.g. <span class="ht-money">…</span> from
            // Shopify.money_format) since the label is written via textContent.
            formattedPrice = formattedPrice.replace(/<[^>]*>/g, '').trim();
            mainLabel = `${addToCartLabel} - ${formattedPrice}`;
          }
        }
      }

      if (this.addBtn) {
        this.addBtn.disabled = shouldDisable;

        if (this.preSelection) {
          this.addBtn.textContent = theme.strings.noSelectedVariant;
        } else {
          this.addBtn.textContent = variantAvailable ? mainLabel : unavailableStr;
        }
      }

      if (stickyAtc) {
        stickyAtc.disabled = shouldDisable;

        if (this.preSelection) {
          stickyAtc.textContent = theme.strings.noSelectedVariant;
        } else {
          stickyAtc.textContent = variantAvailable ? addToCartLabel : unavailableStr;
        }
      }
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Returns the effective (sale / member / regular) price as a plain text
     * string by reading the active price node inside `#pdp-price-container`.
     * `snippets/price.liquid` is the source of truth: it picks the right
     * block based on theme settings and customer tags, and `updateUrl()`
     * re-fetches that container from the server on every variant change, so
     * the DOM always reflects what Liquid would render for the selected
     * variant.
     *
     * Special case: the [MEMBERSHIP] block always renders the member price as
     * the "active" value — even for non-members, as a marketing tease. When
     * the customer is NOT a member, Liquid adds a `no-strike` class to the
     * strike row to suppress the line-through (because the user effectively
     * pays the regular base price, not the member price). This helper checks
     * for that class and returns the strike value in that scenario, so the
     * sticky bar and ATC button show what the customer will actually pay.
     *
     * @returns {?string} Formatted price (e.g. "$2,400") or null if missing.
     */
    getEffectivePriceText() {
      const container = this.section.querySelector('#pdp-price-container');
      if (!container) return null;

      const moneyText = (el) => {
        if (!el) return null;
        const moneyEl = el.querySelector('.ht-money') || el;
        const text = moneyEl.textContent.replace(/\s+/g, ' ').trim();
        return text || null;
      };

      // 1) Sale price — covers both [SALE] and [INDIVIDUAL] blocks.
      const sale = container.querySelector('.price--active-sale');
      if (sale) {
        const text = moneyText(sale);
        if (text) return text;
      }

      // 2) Membership block — must inspect the strike row to know whether the
      //    customer is actually a member or just being shown the tease.
      const member = container.querySelector('.price--active-member');
      if (member) {
        const memberBlock = member.closest('.price-block');
        const strikeRow = memberBlock && memberBlock.querySelector('.price--strike');
        if (strikeRow && strikeRow.classList.contains('no-strike')) {
          const text = moneyText(strikeRow);
          if (text) return text;
        }
        const text = moneyText(member);
        if (text) return text;
      }

      // 3) Regular block — fallback.
      const regular = container.querySelector('.price--regular');
      if (regular) {
        const text = moneyText(regular);
        if (text) return text;
      }

      return null;
    }

    /**
     * Formats a price (in cents) to match price.liquid's
     * `money_without_trailing_zeros` output, so the optimistic value visually
     * matches the server-rendered one (no flash of differing format).
     * @param {number} cents
     * @returns {?string}
     */
    formatVariantPrice(cents) {
      if (typeof cents !== 'number') return null;
      if (typeof Shopify === 'undefined' || typeof Shopify.formatMoney !== 'function') return null;
      // money_format can be an HTML string (e.g. wraps the amount in a span),
      // so strip any tags — we only want the plain "$220" to set as text.
      const formatted = Shopify.formatMoney(cents, Shopify.money_format).replace(/<[^>]*>/g, '');
      // Drop a whole-number ".00" / ",00" tail to mirror money_without_trailing_zeros.
      return formatted.replace(/([.,])00(?=\D*$)/, '').trim();
    }

    /**
     * Optimistically repaints the regular / "From" price from the selected
     * variant before the server fetch returns. No-ops when a discounted block
     * (sale / member) is active, since those require server-side math — the
     * fetch reconciles those a moment later.
     * @param {HTMLElement} container - The #pdp-price-container element.
     */
    prefillRegularPrice(container) {
      if (!container || !this.variant) return;
      // Discounted states need the server; don't risk flashing an undiscounted price.
      if (container.querySelector('.price--active-sale, .price--active-member')) return;
      const moneyNodes = container.querySelectorAll('.price--regular .ht-money');
      if (!moneyNodes.length) return;
      const formatted = this.formatVariantPrice(this.variant.price);
      if (!formatted) return;
      moneyNodes.forEach((node) => { node.textContent = formatted; });
    }

    /**
     * Syncs the sticky ATC bar price with the selected variant's effective
     * price. Prefers the value rendered by `price.liquid` inside
     * `#pdp-price-container` (already discounted for sale / member where
     * applicable). Falls back to `Shopify.formatMoney(variant.price)` if the
     * container is not on the page.
     * @param {?object} variant - Variant whose price should be displayed
     *   (e.g. cheapest in pre-selection, otherwise `this.variant`).
     */
    syncStickyAtcPrice(variant) {
      // Flooring slots (`data-sticky-pps`) show "SQFT / box" and are owned by
      // rs-floor-calculator / rs-panel-calculator — leave those to their scripts.
      const stickyPriceEls = this.section.querySelectorAll('.sticky-container__atc-price:not([data-sticky-pps])');
      if (!stickyPriceEls.length) return;

      const paint = (html) => { stickyPriceEls.forEach((el) => { el.innerHTML = html; }); };

      this.syncStickyMarkdown();

      const effectivePrice = this.getEffectivePriceText();
      if (effectivePrice) {
        paint(`<span>${effectivePrice}</span>`);
        return;
      }

      if (variant
        && typeof variant.price === 'number'
        && typeof Shopify !== 'undefined'
        && typeof Shopify.formatMoney === 'function') {
        paint(`<span>${Shopify.formatMoney(variant.price, Shopify.money_format)}</span>`);
        return;
      }

      // Fallback to the server-formatted string when Shopify globals aren't available.
      if (variant && this.data.formatted[variant.id]) {
        paint(this.data.formatted[variant.id].price);
      }
    }

    /**
     * Mirrors the PDP markdown state onto the sticky bar: the container carries
     * `sticky-container--markdown` (the hook that turns the figure red) and the
     * baseline is filled from the same `.price--strike` node the cluster shows.
     *
     * Read from `#pdp-price-container` rather than the initial variant because
     * the picker re-fetches that container per variant — compare-at can differ
     * between variants, and a server-rendered class would strand a red price on
     * a variant that isn't marked down.
     */
    syncStickyMarkdown() {
      const stickyContainer = this.section.querySelector('#sticky-container');
      const container = this.section.querySelector('#pdp-price-container');
      const isClearance = !!(container && container.querySelector('.price--state-clearance'));
      const productInfo = this.section.querySelector('.product-info');
      if (productInfo) {
        productInfo.classList.toggle('product-info--clearance', isClearance);
      }
      if (stickyContainer) {
        stickyContainer.classList.toggle('sticky-container--clearance', isClearance);
      }
      if (!stickyContainer) return;

      const markdown = container && container.querySelector('.price--pdp-markdown');
      const strike = markdown && markdown.querySelector('.price--strike');
      const wasText = strike
        ? (strike.querySelector('.ht-money') || strike).textContent.replace(/\s+/g, ' ').trim()
        : '';

      stickyContainer.classList.toggle('sticky-container--markdown', !!wasText);
      stickyContainer.querySelectorAll('.sticky-container__atc-price-was').forEach((el) => {
        el.textContent = wasText;
        el.hidden = !wasText;
      });

      // Sale event chip (e.g. BLACK FRIDAY): copied from the price block
      const eventChip = wasText && markdown.querySelector('.product-label--event');
      const chipText = eventChip ? eventChip.textContent.replace(/\s+/g, ' ').trim() : '';
      stickyContainer.classList.toggle('sticky-container--event', !!chipText);
      stickyContainer.querySelectorAll('.sticky-container__chip').forEach((el) => {
        el.textContent = chipText;
        el.hidden = !chipText;
      });
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price .price');

      let { variant } = this;
      if (this.preSelection) {
        variant = this.data.product.variants[0];
        for (let i = 1; i < this.data.product.variants.length; i += 1) {
          if (this.data.product.variants[i].price < variant.price) variant = this.data.product.variants[i];
        }
      }

      if (!this.price) {
        this.syncStickyAtcPrice(variant);
        return;
      }

      if (this.variant) {
       
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const priceWasdisEl = this.price.querySelector('.price__was_dis');
        
        //const unitPriceEl = this.price.querySelector('.unit-price');
    
        const priceSpan = priceCurrentEl.querySelector('.js-value > span');
  
        const discount_percentage_container = this.price.querySelector('#discount_percentage');
       
        // Update price.
        if (discount_percentage_container) {
         
const discount_percentage = this.price.querySelector('#discount_percentage').innerHTML;
  // Assuming priceWasdisEl and priceCurrentdisEl are defined in the broader function scope
  priceWasdisEl.querySelector('.js-value').innerHTML = this.data.formatted[variant.id].price;

  let priceString = this.data.formatted[variant.id].price;

  // Clean the price string
  priceString = priceString.replace(/[^0-9.,]/g, '');
  priceString = priceString.replace(/[.,]/g, '');

  let formattedPrice = parseFloat(priceString).toFixed(2);
  let correct_format = formattedPrice / 100;
  let final_price = correct_format % 1 === 0 
    ? correct_format.toString() 
    : correct_format.toFixed(2);

  const discountVar = 100 - discount_percentage;
  const finalDiscountVariable = discountVar * 0.01;
  const discountedPrice = final_price * finalDiscountVariable;
  const discountedPriceInCents = Math.round(discountedPrice * 100);

  const formattedDiscountedPrice = Shopify.formatMoney(discountedPriceInCents, Shopify.money_format);

  console.log(Shopify.formatMoney(discountedPriceInCents, Shopify.money_format));

  priceCurrentEl.querySelector('.js-value').innerHTML = formattedDiscountedPrice;

} else if (variant.compare_at_price > variant.price) {
        
  priceCurrentEl.querySelector('.js-label').textContent = theme.strings.salePrice;
  priceCurrentEl.querySelector('.js-value').innerHTML = this.data.formatted[variant.id].price;

  if (priceWasEl) {
    priceWasEl.querySelector('.js-label').textContent = theme.strings.regularPrice;
    priceWasEl.querySelector('.js-value').innerHTML = this.data.formatted[variant.id].compareAtPrice || '';
  }

}else {

  priceCurrentEl.querySelector('.js-label').textContent = theme.strings.regularPrice;
  priceCurrentEl.querySelector('.js-value').innerHTML = this.data.formatted[variant.id].price;

  if (priceWasEl) {
    priceWasEl.querySelector('.js-label').textContent = '';
    priceWasEl.querySelector('.js-value').innerHTML = '';
  }
}

   // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
     
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;ed
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        //unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available && !this.preSelection);
      }

      const priceDefault = this.price.querySelector('.price__default');
      if (priceDefault) {
        priceDefault.hidden = !this.variant && !this.preSelection;
      }
      const noVariantEl = this.price.querySelector('.price__no-variant');
      if (noVariantEl) {
        noVariantEl.hidden = this.variant || this.preSelection;
      }
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }

      this.syncStickyAtcPrice(variant);
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      // Merge variant into the existing query string. Overwriting with
      // `?variant=<id>` dropped ttclid / utm_* / tw_adid (Dawn #2551).
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', this.variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) {
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
      }
      console.clear();
      // Start fetch logic to update #pdp-price-container
      const container = this.section.querySelector('#pdp-price-container');
      if (!this.variant || !container || !this.dataset.url) return;

      // Optimistic instant update: when the visible price has no server-side
      // discount (regular / non-member "From" price), the displayed value is
      // simply the variant price, which we already know client-side. Paint it
      // immediately so the change feels instant; the fetch below reconciles
      // sale / member / discount-chip states from the server source of truth.
      this.prefillRegularPrice(container);

      const variantUrl = `${this.dataset.url}?variant=${this.variant.id}`;
      fetch(variantUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newPriceContainer = doc.querySelector('#pdp-price-container');

          if (newPriceContainer) {
            container.innerHTML = newPriceContainer.innerHTML;
          }
          // Now that #pdp-price-container holds the effective sale / member /
          // regular price for this variant, re-sync the sticky bar AND the
          // main "Add to cart" label so both reflect the discounted value.
          this.syncStickyAtcPrice(this.variant);
          this.updateAddToCartButton();
        })
        .catch(err => console.error('Price update failed:', err));
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selectedText = selector.querySelector('.custom-select__btn').textContent.trim();
          selectedOptions.push(selectedText === this.dataset.placeholderText ? null : selectedText);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find(
        (v) => v.options.every((val, index) => val === selectedOptions[index])
      );
    }
  }

  customElements.define('variant-picker', VariantPicker);
}